import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {Field} from 'redux-form';
import {RESOURCES as locationResources} from '../fuseLocationsResourceMap';
import {getGetHeaders} from '../shared/serverFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A form containing a Virtualized Select component
 *
 */
class LocationSelectField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            locationsList: [],
            selectedLocation: null,
        };
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
    }

    componentDidMount() {
        this.fetchLocationsData();
    }

    /* API Calls ------------------------------ */

    /**
     * Get list of Locations for filter
     */
    fetchLocationsData() {
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: "id", order: "ASC"}
        };
        const resource = locationResources.Locations.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                const locations = this.processLocationsData(result.data.payload);
                this.setState({
                    locationsList: locations
                }, () => {
                    if (typeof this.props.onLocationsLoaded === 'function') {
                        this.props.onLocationsLoaded(locations);
                    }
                });
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Format Location display names for filter
     *
     * @param list
     * @return {Array}
     */
    processLocationsData(list) {
        let locationsList = [];
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (item) {
                    const id = (item.id) ? item.id.toString() : '';
                    const name = (item.name) ? ' - ' + item.name.toString() : '';
                    const city = (item.city) ? ' - ' + item.city.toString() : '';
                    const state = (item.state) ? ' - ' + item.state.toString() : '';
                    item.filter_name = id + name + city + state;
                    locationsList.push(item);
                }
            }
        }
        return locationsList;
    }

    /**
     * Handle selection event for Location
     *
     * @param event
     * @param index
     * @param value
     */
    handleLocationSelect(event, index, value) {
        if (index && index !== value) {
            // Extract the full Location object from the selected location_id
            const locationObj = this.state.locationsList.find(n => n.id === index);
            if (locationObj) {
                this.setState({
                    selectedLocation: locationObj,
                }, () => {
                    if (this.props.selectionType === 'object') {
                        this.props.onSelectLocation('location', locationObj);
                    }
                    if (this.props.selectionType === 'id') {
                        this.props.onSelectLocation('location', locationObj.id.toString());
                    }
                });
            }
        }
    }

    render() {
        const {
            label
        } = this.props;

        const {
            locationsList
        } = this.state;

        return (
            <Field name="location_id"
                   component={VirtualizedSelectInput}
                   choices={locationsList}
                   label={label}
                   optionText="filter_name"
                   optionValue="id"
                   onChange={this.handleLocationSelect}
                   allowEmpty
                   options={{
                       className: "has-label inline",
                       clearable: true,
                       placeholder: label
                   }}
            />
        );
    }
}

LocationSelectField.propTypes = {
    label: PropTypes.string,
    onLocationsLoaded: PropTypes.func,
    onSelectLocation: PropTypes.func,
    selectionType: PropTypes.string
};

LocationSelectField.defaultProps = {
    label: 'Select a Location:',
    onLocationsLoaded: null,
    selectionType: 'object'
};

export default LocationSelectField;



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationSelectField.js